module.exports = __webpack_public_path__ + "static/kohli-5bb7aeac4f85217386afe0e30ac816cc.png";